import React from "react"
import { IconColorsType } from "../"
import { camelize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "carGroup"
const CarGroupIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.913 3c1.381 0 2.507.673 3.34 1.8H6.978c-3.195 0-3.195 3.6-3.195 4.5h1.41c-.115.28-.217.565-.307.852-.103.326-.19.644-.262.95a1.359 1.359 0 0 0-1.298 1.348c0 .597.394 1.104.94 1.282-.018.319-.027.642-.027.968v2.7H2.413a.907.907 0 0 1-.913-.9v-5.4c0-.309.009-.613.026-.912 0-.438.093-1.685.539-3.103C2.834 4.638 4.366 3 6.522 3h6.391Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.087 6.6c-1.717 0-3.04 1.04-3.895 2.7a8.763 8.763 0 0 0-.562 1.385c-.446 1.418-.54 2.665-.54 3.102-.016.3-.025.604-.025.913v5.4c0 .497.409.9.913.9h1.826a.907.907 0 0 0 .913-.9v-.9h9.13v.9c0 .497.41.9.914.9h1.826a.907.907 0 0 0 .913-.9v-5.4c0-.309-.009-.613-.026-.912-.024-.438-.386-2.617-.539-3.103-.769-2.447-2.301-4.085-4.457-4.085h-6.391ZM17.7 8.46a3.658 3.658 0 0 0-.678-.06h-5.478c-1.024 0-1.719.369-2.192.9-.455.511-.704 1.172-.84 1.8-.164.757-.164 1.465-.164 1.8h11.87c0-.831 0-3.965-2.518-4.44Zm-7.147 7.14a1.369 1.369 0 0 0-1.292-.9c-.596 0-1.104.376-1.292.9a1.33 1.33 0 0 0-.078.45c0 .746.613 1.35 1.37 1.35a1.36 1.36 0 0 0 1.37-1.35c0-.158-.028-.31-.079-.45Zm7.382.45c0 .746.613 1.35 1.37 1.35a1.36 1.36 0 0 0 1.369-1.35 1.36 1.36 0 0 0-1.37-1.35 1.36 1.36 0 0 0-1.37 1.35Z"
      />
    </svg>
  )
}
export default CarGroupIcon
